import { useNewTranslations } from '@/common/translations';
import { Section } from '@/ui/components';

import { TopGoalscorers, type TopGoalscorer } from '../../../components';
import { ApiWidgetType, StatsTypes } from '../../../constants';
import type { Goalscorer } from '../../../types';
import { useStatsData } from '../../../hooks';

const TopScorers = () => {
  const translate = useNewTranslations();
  const { teams, widget } = useStatsData({
    widgetType: StatsTypes.TOP_SCORERS,
  });

  if (!widget || widget.type !== ApiWidgetType.TOP_SCORERS || !widget?.data) {
    return null;
  }

  const mapGoalscorer = (goalscorer: Goalscorer): TopGoalscorer => ({
    name: goalscorer.name,
    goals: goalscorer.goals,
    position: translate(goalscorer.position),
    flagSrc: goalscorer.flag ?? undefined,
  });

  return (
    <Section name={translate('PreMatchStats.TopGoalscorers')}>
      <TopGoalscorers
        homeJerseySrc={teams.home.jersey}
        awayJerseySrc={teams.away.jersey}
        homeTopGoalscorers={widget.data.home.map(mapGoalscorer)}
        awayTopGoalscorers={widget.data.away.map(mapGoalscorer)}
      />
    </Section>
  );
};

export default TopScorers;
